import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { CatAndSubCatDefaultCategoryFragmentDoc } from './CatAndSubCatDefaultCategory.generated'
import * as Types from './purchasePlus_graphql'

export const CreateProductInformationDefaultCategoryFragmentDoc = gql`
  fragment CreateProductInformationDefaultCategory on Category {
    id
    ...CatAndSubCatDefaultCategory
  }
  ${CatAndSubCatDefaultCategoryFragmentDoc}
` as unknown as DocumentNode<Types.CreateProductInformationDefaultCategoryFragment, unknown>
